var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags is-rounded has-addons"},[_c('span',{staticClass:"tag is-rounded"},[_vm._v("Risk Level")]),_c('span',{staticClass:"tag is-rounded",class:{
    'is-warning': _vm.level === 'low',
    'is-strong-warning': _vm.level === 'medium',
    'is-danger': _vm.level === 'high' || _vm.level === 'critical'
  }},[_vm._v(" "+_vm._s(_vm._f("ucwords")(_vm.level))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }